import { memo, useState } from 'react';
import { Handle, Position, Node, NodeProps } from '@xyflow/react';
import { Select, SelectItem } from '@ubiquitel/ui';

import { UbiverseClient } from '../../../../types';
import './index.scss';

export type SimulatorNodeData = {
  label: string;
  sessionList: UbiverseClient[];
  selectedClientId: string | null;
  onSelectClient: (nodeId: string, clientId: string | null) => void;
};
type SimulatorNodeProp = Node<SimulatorNodeData>;

export default memo(({ id, data, isConnectable }: NodeProps<SimulatorNodeProp>) => {
  const { sessionList = [], selectedClientId, onSelectClient } = data;
  const selectedSession = sessionList.find(s => s.id === selectedClientId);

  return (
    <div className="node--simulator">
      <Handle
        type="target"
        position={Position.Left}
        isConnectable={isConnectable}
      />
      <div className="node--simulator__header">
        <h6 className="node--simulator__title">{data.label || 'Device'}</h6>
        <div className={`node--simulator__status-dot ${selectedSession ? 'connected' : ''}`} />
      </div>

      <div className="node--simulator__body">
        {sessionList.length === 0 ? (
          <p className="node--simulator__info__empty">
            No devices on the network. Connect an ESP32 finger, or open <code>/sim</code> in a new tab to launch a browser simulator.
          </p>
        ) : (
          <>
            <Select
              value={selectedClientId || ''}
              onValueChange={(value) => {
                onSelectClient(id, value || null);
              }}
              placeholder="Select device..."
              fixedWidth="auto"
              className="node--simulator__select"
            >
              {sessionList.map((session) => (
                <SelectItem key={session.id} value={session.id}>
                  {session.data?.label || session.hardware_id || session.id.slice(0, 8)}
                  {session.kind === 'device' ? ' (device)' : ''}
                  {session.auth?.isAuthenticated ? '' : ' (guest)'}
                </SelectItem>
              ))}
            </Select>

            {selectedSession && (
              <div className="node--simulator__info">
                <p className="node--simulator__info__label">
                  {selectedSession.data?.label || selectedSession.hardware_id || 'Unnamed'}
                </p>
                <p className="node--simulator__info__detail">
                  {selectedSession.kind === 'device' ? 'ESP32 device' : 'Simulator'}
                  {' · '}
                  {selectedSession.auth?.isAuthenticated ? 'Authenticated' : 'Guest'}
                </p>
              </div>
            )}

            {!selectedSession && selectedClientId && (
              <p className="node--simulator__info__disconnected">Session disconnected</p>
            )}
          </>
        )}
      </div>
    </div>
  );
});
